var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clients"},[_c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"pills":"","card":"","vertical":""}},[_c('b-tab',{attrs:{"title":"Adicionar"}},[_c('new-client')],1)],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }